/** Coerce a stored amount (number or interim input string) to a finite number. */
export function toFiniteNumber(value, fallback = 0) {
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  if (value === '' || value === '-' || value === '.' || value === '-.' || value == null) {
    return fallback;
  }
  const n = Number(String(value).replace(/,/g, '').trim());
  return Number.isFinite(n) ? n : fallback;
}

/**
 * Parse signed decimal from an input.
 * Returns '' / '-' / '-.' / trailing '.' while typing, a number when complete,
 * or `null` when the keystroke should be ignored.
 */
export function parseSignedNumberInput(raw) {
  if (raw === null || raw === undefined) return null;
  const s = String(raw).trim();
  if (s === '') return '';
  // Allow only optional leading minus + digits + optional single decimal
  if (!/^-?\d*\.?\d*$/.test(s)) return null;
  if (s === '-' || s === '.' || s === '-.' || /^-?\d+\.$/.test(s) || /^-?\.\d+$/.test(s)) {
    return s;
  }
  const n = Number(s.replace(/,/g, ''));
  return Number.isFinite(n) ? n : null;
}
